const VALIDATION_DEFAULTS = {
  profilePictureRequired: 'Profile picture is required',
  profilePictureInvalid:
    'Profile picture data is invalid or empty. Please upload a valid picture.',
  profilePictureTooSmall:
    'Profile picture data is too small or invalid. Please upload a valid picture.',
  emailRequired: 'Email is required',
  emailInvalid: 'Enter a valid email address',
  firstNameRequired: 'First name is required',
  dateOfBirthRequired: 'Date of Birth is required',
  surnameRequired: 'Surname is required',
  phoneRequired: 'Phone number is required',
  companyRequired: 'Company is required',
  accessRequired: 'Access is required',
  roleRequired: 'Role is required',
  validFromAfterExpiresAt: 'Valid From date cannot be after Expires At date',
  expiresAtBeforeValidFrom: 'Expires At date cannot be before Valid From date',
};

const getValidationMessage = (translate, key) => {
  if (typeof translate === 'function') {
    const translationKey = `validation.${key}`;
    const translated = translate(translationKey);
    if (translated && translated !== translationKey) {
      return translated;
    }
  }
  return VALIDATION_DEFAULTS[key];
};

// Shared validation logic for profile creation and activation
export const validateProfile = (profileData, image, translate) => {
  const errors = {};

  // Strict validation: Profile picture is required and must have valid data
  if (!image) {
    errors.image = getValidationMessage(translate, 'profilePictureRequired');
  } else {
    // Check for invalid/empty base64 data (e.g., "data:image64," or "data:image/jpeg;base64,")
    const trimmedImage = image.trim();
    if (trimmedImage === 'data:image64,' || 
        trimmedImage.endsWith('base64,') || 
        !trimmedImage.includes(',')) {
      errors.image = getValidationMessage(translate, 'profilePictureInvalid');
    } else {
      // Extract base64 part and validate it has sufficient content
      const parts = trimmedImage.split(',');
      if (parts.length < 2 || !parts[1] || parts[1].trim().length < 100) {
        errors.image = getValidationMessage(translate, 'profilePictureTooSmall');
      }
    }
  }

  if (!profileData.email) {
    errors.email = getValidationMessage(translate, 'emailRequired');
  } else if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(profileData.email)) {
    errors.email = getValidationMessage(translate, 'emailInvalid');
  }

  if (!profileData.firstName) {
    errors.firstName = getValidationMessage(translate, 'firstNameRequired');
  }

  if (!profileData.dateOfBirth) {
    errors.dateOfBirth = getValidationMessage(translate, 'dateOfBirthRequired');
  }

  if (!profileData.surname) {
    errors.surname = getValidationMessage(translate, 'surnameRequired');
  }

  if (!profileData.phone) {
    errors.phone = getValidationMessage(translate, 'phoneRequired');
  }

  if (!profileData.company) {
    errors.company = getValidationMessage(translate, 'companyRequired');
  }

  if (!profileData.access) {
    errors.access = getValidationMessage(translate, 'accessRequired');
  }

  if (!profileData.role) {
    errors.role = getValidationMessage(translate, 'roleRequired');
  }

  if (profileData.validFrom && profileData.expiresAt && profileData.validFrom.isAfter(profileData.expiresAt)) {
    errors.validFrom = getValidationMessage(translate, 'validFromAfterExpiresAt');
    errors.expiresAt = getValidationMessage(translate, 'expiresAtBeforeValidFrom');
  }

  return errors;
};

export const validateDraft = (profileData, translate) => {
  const errors = {};

  if (!profileData.firstName) {
    errors.firstName = getValidationMessage(translate, 'firstNameRequired');
  }

  if (!profileData.surname) {
    errors.surname = getValidationMessage(translate, 'surnameRequired');
  }

  if (!profileData.email) {
    errors.email = getValidationMessage(translate, 'emailRequired');
  } else if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(profileData.email)) {
    errors.email = getValidationMessage(translate, 'emailInvalid');
  }

  return errors;
}; 